import { render, staticRenderFns } from "./InternsEditor.vue?vue&type=template&id=4b9508ea&scoped=true&"
import script from "./InternsEditor.vue?vue&type=script&lang=ts&"
export * from "./InternsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./InternsEditor.vue?vue&type=style&index=0&id=4b9508ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9508ea",
  null
  
)

export default component.exports